import React from 'react'
import styled from 'styled-components'
import { Button } from '../styles'

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    color: black;
    padding: 12px;

    div {
        max-width: 420px;
        text-align: center;
    }
`
const MockBank = ({setConnected, closeSDK, selectedBank}) => {
    const approve = () => {
        setConnected(true)
        closeSDK()
    }
    return (
        <Container>
            <div>
                <h1>{selectedBank} website</h1>
                <p>In Open Banking your users are redirected to their bank's website or application at this point to complete their connection. This varies from bank to bank - but for the purposes of this demonstration click the approve button below to see the data returned.</p>
                <Button onClick={() => approve()}>Approve</Button>
            </div>
        </Container>
    )
}

export default MockBank